import * as React from 'react';
import { TypographyProps } from '../typography-props';
import { BaSeTypographyWrapper } from '../typography-wrapper';
import { StyledSmall2 } from './small2-styled';

export const BaSeSmall2: React.FC<TypographyProps> = (props) => (
  <BaSeTypographyWrapper
    fontSize={0.69}
    lineHeight={1.2}
    wrapper={StyledSmall2}
    {...props}
  >
    {props.children}
  </BaSeTypographyWrapper>
);

BaSeSmall2.displayName = 'BaSeSmall2';
